import { useEffect } from 'react';
import { Blocker, useBlocker } from 'react-router-dom';
import { isElectronApp } from '@hooks/use-is-electron.ts';
import { PageLifecycleEventEnum } from '@models/global.model.ts';
import useTokenStore from '@store/token-store/token.store.ts';

export const useUnsavedChangesGuard = (hasChanges: boolean): Blocker => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      hasChanges && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    if (!hasChanges || isElectronApp()) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!useTokenStore.getState().accessToken) return;
      event.preventDefault();
    };

    window.addEventListener(
      PageLifecycleEventEnum.BeforeUnload,
      handleBeforeUnload
    );
    return () =>
      window.removeEventListener(
        PageLifecycleEventEnum.BeforeUnload,
        handleBeforeUnload
      );
  }, [hasChanges]);

  return blocker;
};
